import React from 'react'
import { Container, useMantineTheme } from '@mantine/core'
import { useMediumScreen } from '@/hooks'

interface Props {
  narrow?: boolean
  children: React.ReactNode
}

const AirdropContainer: React.FC<Props> = ({ children, narrow }) => {
  const theme = useMantineTheme()

  const { isMediumScreen } = useMediumScreen()

  return (
    <Container
      size={narrow ? 'sm' : theme.other.airdropPage.width}
      px={isMediumScreen ? 'lg' : 'sm'}
      pt={isMediumScreen ? 80 : 'xl'}
      pb="xl"
      sx={{ position: 'relative' }}>
      {children}
    </Container>
  )
}

export { AirdropContainer }
